import { DownloadIcon } from "components/common/Icons/DownloadIcon";
import { Loader } from "components/common/Icons/Loader/Loader";
import { Translate } from "components/common/Translate/Translate";
import { useDownloadAll } from "../../../Preview/DownloadAll/useDownloadAll";

export const DownloadAll = () => {
    const { images, handleDownloadAll, isDownloading, isExporting } = useDownloadAll();
    const isActive = images.length > 0 && images.every((img) => img.state === "compressed");
    const getTranslationKey = () => {
        const compressedImagesCount = images.filter((img) => img.state === "compressed").length;
        const compressingImagesCount = images.filter((img) => img.state === "compressing").length;

        if (compressingImagesCount === 1) {
            return "common:download-image";
        } else if (compressingImagesCount > 1) {
            return "common:download-all-images";
        } else if (compressedImagesCount === 1) {
            return "common:download-image";
        } else if (compressedImagesCount > 1) {
            return "common:download-all-images";
        }
        return "common:download-image";
    };

    return (
        <div
            className={`flex items-center justify-center gap-4 flex-grow text-white font-semibold sm:text-xl border-r border-r-irBlue-400 py-4 ${
                isActive ? "cursor-pointer " : " bg-gray-400 text-white-600"
            }`}
            onClick={isActive ? handleDownloadAll : undefined}
        >
            <div className="">
                {isDownloading || isExporting ? (
                    <Loader className="stroke-white" width={20} height={20} />
                ) : (
                    <DownloadIcon />
                )}
            </div>
            <div className="capitalize">
                <Translate keyName={getTranslationKey()} />
            </div>
        </div>
    );
};
